import React from "react"
import { Helmet } from "react-helmet"
import slugify from "slugify"
import defaultThumb from "../images/metaimage.png"

function getSocialCard({ title, image }) {
  if (image) {
    const ext = image.split(".").pop()
    // URL guaranteed by src/gatsby-remark-social-card

    const slugifiedTitle = slugify(title, {
      remove: /[*+~.()[\]{}'"!?/:@,]/g,
    }).toLowerCase()

    return `/social-cards/${slugifiedTitle}.${ext}`
  } else {
    return ""
  }
}

// borrowed from https://stackoverflow.com/questions/29855098/is-there-a-built-in-javascript-function-similar-to-os-path-join/46427607
function buildPath(...args) {
  return args
    .filter(Boolean)
    .map((part, i) => {
      if (i === 0) {
        return part.trim().replace(/[\/]*$/g, "")
      } else {
        return part.trim().replace(/(^[\/]*|[\/]*$)/g, "")
      }
    })
    .filter((x) => x.length)
    .join("/")
}

export default (props) => {
  const title = [props.title, props.siteTitle].filter(Boolean).join(" | ")

  const description = props.description || props.siteDescription

  const siteUrl = props.siteUrl

  const socialImage = getSocialCard({
    title: props.title,
    image: props.image,
  })
  const image = buildPath(siteUrl, socialImage || defaultThumb)
  const url = buildPath(
    siteUrl,
    props.location?.pathname ? props.location.pathname : ""
  )

  const rightMessageId = process.env.GATSBY_RIGHTMESSAGE_ID

  return (
    <Helmet
      htmlAttributes={{
        lang: "en-us",
      }}
    >
      <title>{title}</title>
      <link rel="icon" href="/icon.png" />
      <meta name="description" content={description} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@swizec" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />{" "}
      <meta name="twitter:image" content={image} />
      <meta property="og:title" content={title} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <script src="https://gumroad.com/js/gumroad.js"></script>
      {rightMessageId && props.showRightMessage && (
        <script type="text/javascript">{`
                    (function(p, a, n, d, o, b, c) {
                        o = n.createElement('script'); o.type = 'text/javascript'; o.async = true; o.src = 'https://tag.rightmessage.com/'+p+'.js';
                        o = n.createElement('script'); o.id = 'rightMessageScript'; o.type = 'text/javascript'; o.async = true; o.src = 'https://tag.rightmessage.com/'+p+'.js';
    b = n.getElementsByTagName('script')[0]; d = function(h, u, i) { var c = n.createElement('style'); c.id = 'rmcloak'+i;
        c.type = 'text/css'; c.appendChild(n.createTextNode('.rmcloak'+h+'{visibility:hidden}.rmcloak'+u+'{display:none}'));
                    b.parentNode.insertBefore(c, b); return c; }; c = d('', '-hidden', ''); d('-stay-invisible', '-stay-hidden', '-stay');
    setTimeout(o.onerror = function() {c.parentNode && c.parentNode.removeChild(c); }, a); b.parentNode.insertBefore(o, b);
                })(${rightMessageId}, 20000, document);
      `}</script>
      )}
    </Helmet>
  )
}
